import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { CaseStatus } from "../../constants";
import StatusTag from "../../components/StatusTag";



const CasesPendingDialog = ({visible, onClose, staleCases }) => {
  return (
    <Dialog
      draggable={false}
      visible={visible}
      onHide={() => onClose(false)}
      header="Tienes casos pendientes"
      headerClassName="pb-2"
      className="md:w-7"
    >
      <div className="p-fluid">
        <p>
          Tienes{" "}
          {staleCases.isLoading ? (
            <i className="pi pi-spin pi-spinner "></i>
          ) : (
            <b className="text-2xl text-red-600">{staleCases.data?.count}</b>
          )}{" "}
          casos pendientes por cambio de estatus. Para seguir recibiendo nuevos
          pacientes debes dar respuesta a estos casos:
        </p>
        <ul className="flex flex-column gap-2">
          <li>
            Tendrás hasta <strong>7</strong> días para cambiar los casos de{" "}
            <StatusTag value={CaseStatus.PENDIENTE} /> a{" "}
            <StatusTag value={CaseStatus.RESCHEDULED} />.
          </li>
          <li>
            Tendrás hasta <strong>35</strong> días para cambiar los casos de{" "}
            <StatusTag value={CaseStatus.RESCHEDULED} /> a{" "}
            <StatusTag value={CaseStatus.ATENDIDO} />.
          </li>
        </ul>
        <p>
          Si marcas un caso como <StatusTag value={CaseStatus.ANULADO} />, este
          podría ser asignado a otro Centro Médico.
        </p>
        <div className="flex justify-content-end gap-2">
          {/* <Button
                        label="No mostrar más por hoy"
                        className="w-fit"
                        text
                        severity="secondary"
                        onClick={() => {
                          const tomorrow = new Date();
                          tomorrow.setDate(tomorrow.getDate() + 1);
                          localStorage.setItem(
                            "hideModalUntil",
                            tomorrow.toISOString()
                          );
                          setShowDialog(false);
                        }}
                      /> */}
          <Button
            label="Continuar"
            className="w-fit px-6"
            onClick={() => onClose(false)}
            disabled={staleCases.isLoading}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default CasesPendingDialog;
